const INTERVENE_LIST_UPDATED = 'intervene.list.updated';

function isInboundMessage(event) {
  const message = event?.last_message || event?.data?.last_message || event;
  return String(message?.origin || '').toUpperCase() === 'INBOUND';
}

function getNotificationEvent(payload) {
  const event = payload?.payload ?? payload;
  return event?.data?.type === INTERVENE_LIST_UPDATED ? event.data : event;
}

function showLeadAssignmentNotification(event, userId) {
  if (userId == null || userId === '') return null;

  const leads = Array.isArray(event?.data) ? event.data : [event?.data];
  const assignedLead = leads.find((lead) =>
    (lead?.lead_assignment || []).some(
      (assignment) => String(assignment?.lead_assigned_to ?? '') === String(userId)
    )
  );
  if (!assignedLead) return null;

  const leadId = assignedLead.lead_id || assignedLead.id || 'New lead';
  const notification = new Notification('A lead was assigned to you', {
    body: `Lead ${leadId} has been assigned to you.`,
    tag: `lead-assignment-${leadId}`,
    renotify: true,
    icon: '/favicon.ico',
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
  };

  return notification;
}

export function requestDesktopNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return Promise.resolve('unsupported');
  }

  if (Notification.permission !== 'default') {
    return Promise.resolve(Notification.permission);
  }

  return Notification.requestPermission();
}

export function showInterveneDesktopNotification(payload, userId) {
  if (
    typeof window === 'undefined'
    || !('Notification' in window)
    || Notification.permission !== 'granted'
  ) {
    return null;
  }

  const event = payload?.payload ?? payload;
  const notificationType = event?.notification_type || event?.data?.notification_type;
  if (notificationType === 'new_leads') {
    return showLeadAssignmentNotification(event, userId);
  }

  if (!document.hidden) return null;

  const data = getNotificationEvent(payload);
  if (event?.type !== INTERVENE_LIST_UPDATED && data?.type !== INTERVENE_LIST_UPDATED) return null;

  // List updates are emitted for both customer messages and agent replies.
  // Desktop notifications should only alert for a new incoming customer message.
  if (!isInboundMessage(event?.data || data)) return null;

  const phoneNumber = data.phone_number || '';
  const name = data.whatsapp_name || phoneNumber || 'WhatsApp user';
  const preview = data.last_message_preview || data.last_message?.content?.text || 'New message received';

  const notification = new Notification(`New message from ${name}`, {
    body: preview,
    tag: `intervene-${phoneNumber || event.event_id || Date.now()}`,
    renotify: true,
    icon: '/favicon.ico',
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
  };

  return notification;
}
